import { useNavigate } from "react-router-dom";
import { Printer, Package, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { openLabels } from "@/lib/api";

export const LabelsPrompt = ({ wine, created, onDone }) => {
  const navigate = useNavigate();
  const name = `${wine.name} ${wine.vintage || "NV"}`;
  const bottles = created.bottles.map((barcode) => ({ barcode, title: wine.name, wine: name }));
  const box = created.box && { barcode: created.box.barcode, kind: "box", box_number: created.box.box_number };
  const go = (labels) => {
    onDone();
    openLabels(labels, navigate);
  };
  return (
    <div className="space-y-5 mt-2" data-testid="labels-prompt">
      <div className="flex items-start gap-3 rounded-lg border border-[#2E252A] bg-[#0D0A0B] p-4">
        <Check className="w-5 h-5 text-[#D4AF37] mt-0.5" />
        <div>
          <p className="text-[#F5F0EB]" data-testid="labels-prompt-title">{name} saved</p>
          <p className="text-xs text-[#A89F91] font-mono mt-1" data-testid="labels-prompt-codes">
            {created.bottles.length} bottle{created.bottles.length === 1 ? "" : "s"}: {created.bottles[0]}{created.bottles.length > 1 ? ` – ${created.bottles[created.bottles.length - 1]}` : ""}{box ? ` · Box ${box.box_number}` : ""}
          </p>
        </div>
      </div>
      <p className="text-sm text-[#A89F91]">Print the labels now?</p>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => go(bottles)} className="bg-[#D4AF37] hover:bg-[#E5A93C] text-[#0D0A0B]" data-testid="labels-prompt-bottles"><Printer className="w-4 h-4 mr-2" />{bottles.length} bottle label{bottles.length === 1 ? "" : "s"}</Button>
        {box && <Button variant="outline" onClick={() => go([box])} data-testid="labels-prompt-box"><Package className="w-4 h-4 mr-2" />Box label</Button>}
        {box && <Button variant="outline" onClick={() => go([box, ...bottles])} data-testid="labels-prompt-all">Box + bottles</Button>}
        <Button variant="ghost" onClick={onDone} className="ml-auto" data-testid="labels-prompt-later">Later</Button>
      </div>
    </div>
  );
};
